import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  updateDefaultInterfaceAction,
  fetchDefaultInterfaceAction
} from "actions/user-settings-actions";
import { Loading } from "components/common/loading";
import { BetaSetting } from "components/settings/beta-setting";

class BetaSettingsPage extends React.Component {
  componentWillMount() {
    this.props.init();
  }
  render() {
    if (this.props.isLoading) {
      return <Loading />;
    }
    return (
      <BetaSetting { ...this.props } />
    );
  }
}

BetaSettingsPage.propTypes = {
  init: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  accounts: state.app.accounts,
  favouriteAccountId: state.userSettings.favouriteAccountId,
  isBetaDefault: state.userSettings.isBetaDefault,
  isLoading: state.userSettings.isBetaDefaultLoading,
  isUpdateDefaultInterfaceLoading: state.userSettings.isUpdateDefaultInterfaceLoading
});

const mapDispatchToProps = (dispatch) => ({
  init: () => dispatch(fetchDefaultInterfaceAction()),
  onUpdateDefaultInterface: (isBetaDefault) => dispatch(updateDefaultInterfaceAction(isBetaDefault))
});

export const BetaSettingsContainer = connect(mapStateToProps, mapDispatchToProps)(BetaSettingsPage);



// WEBPACK FOOTER //
// ./src/js/containers/settings/beta-settings-container.jsx